import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '../../compat/muiStyles';
import mainStyle from '../../assets/mainStyle';
import { getBatteryVoltage } from '../../utils/readings';

const useStyles = makeStyles({
  ...mainStyle,
  root: {},
});

const Settings = {
  Name: 'Battery',
  Display: true,
  document: {
    url: '/widgets/battery',
    label: 'Battery Document',
  },
  options: {
    view: null,
    settings: [
      {
        id: 'units',
        type: 'text',
        name: 'Units',
      },
    ],
    grid: true,
  },
};

const View = ({ DeviceData, Settings }) => {
  useStyles();
  const battery = DeviceData && DeviceData[0] ? getBatteryVoltage(DeviceData[0]) : undefined;

  return (
    <Box>
      {battery ?? ''} {Settings.units || null}
    </Box>
  );
};

export default {
  Settings,
  View,
};
